import React from "react";
import "../../assets/styles/ChatBubble.css";
import PropTypes from "prop-types";

const ChatBubble = ({
                        onClick,
                        isActive,
                        onMouseDown,
                        isDragging,
                        style,
                    }) => {
    return (
        <button
            type="button"
            onClick={onClick}
            onMouseDown={onMouseDown}
            style={style}
            className={`chat-bubble ${isActive ? "active" : ""} ${
                isDragging ? "dragging" : ""
            }`}
        >
            <div className={`icon-container ${isActive ? "rotated" : ""}`}>
                <svg
                    className="icon"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <rect x="2" y="8" width="20" height="12" rx="2" ry="2" />
                    <path d="M12 8V4M8 4h8" />
                    <circle cx="8" cy="14" r="1" />
                    <circle cx="16" cy="14" r="1" />
                </svg>
            </div>
        </button>
    );
};

ChatBubble.propTypes = {
    onClick: PropTypes.func.isRequired,
    onMouseDown: PropTypes.func,
    isActive: PropTypes.bool.isRequired,
    isDragging: PropTypes.bool,
    style: PropTypes.object,
};

export default ChatBubble;